export default __webpack_public_path__ + "static/media/celebrationBackground.68d8151f.gif";